import React from "react";

export default class UserCheck extends React.Component {
  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const destination = decodeURIComponent(params.get("userCheckReturnTo"));
    window.location.replace(
      `${window.location.protocol}//${window.location.host}${destination}`
    );
  }

  render() {
    return null;
  }
}
